
export default function Platforms() {
  const platforms = [
    { name: 'Spotify', icon: 'ri-spotify-fill', color: 'hover:text-green-500', link: 'https://open.spotify.com/album/628RYfi6grfGn6z0lU80tR?referral=labelaffiliate&utm_source=1011lBPbcChg&utm_medium=Indie_Distrokid&utm_campaign=labelaffiliate' },
    { name: 'Apple Music', icon: 'ri-apple-fill', color: 'hover:text-pink-500', link: 'https://music.apple.com/us/album/chicago-heartbreak/1855286290?uo=4&app=music&at=1001lry3&ct=dashboard' },
    { name: 'YouTube Music', icon: 'ri-youtube-fill', color: 'hover:text-red-500', link: 'https://youtube.com/channel/UCF5GtB4OAv1llPWErmV-Img?si=AGjt8lm0jYIuPoV-' },
    { name: 'iHeart Radio', icon: 'ri-heart-fill', color: 'hover:text-red-400', link: 'https://www.iheart.com/artist/etc-30048583/albums/chicago-heartbreak-361847219' },
    { name: 'Tidal', icon: 'ri-music-fill', color: 'hover:text-blue-500', link: 'https://tidal.com/album/475112068/u' },
    { name: 'iTunes', icon: 'ri-apple-fill', color: 'hover:text-purple-500', link: 'https://music.apple.com/us/album/chicago-heartbreak/1855286290' },
  ];

  return (
    <section className="py-24 px-6 bg-gradient-to-b from-black via-zinc-950 to-black">
      <div className="max-w-6xl mx-auto text-center">
        <h2 className="text-5xl md:text-6xl font-black mb-6 text-white">
          STREAM IT EVERYWHERE
        </h2>
        <p className="text-xl text-gray-400 mb-16">
          Now available on all major platforms
        </p>

        <div className="grid grid-cols-2 md:grid-cols-3 lg:grid-cols-6 gap-8">
          {platforms.map((platform) => (
            <a
              key={platform.name}
              href={platform.link}
              className="group flex flex-col items-center gap-4 p-6 bg-zinc-900/50 border-2 border-zinc-800 hover:border-red-600 transition-all duration-300 cursor-pointer"
            >
              <i className={`${platform.icon} text-6xl text-gray-400 ${platform.color} transition-colors duration-300 w-16 h-16 flex items-center justify-center`}></i>
              <span className="text-sm font-semibold text-gray-300 group-hover:text-white transition-colors duration-300">
                {platform.name}
              </span>
            </a>
          ))}
        </div>

        {/* Out Now Banner */}
        <div className="mt-20 p-12 bg-gradient-to-r from-red-600/20 via-red-600/10 to-red-600/20 border-2 border-red-600/50">
          <div className="text-center">
            <div className="text-6xl md:text-7xl font-black text-red-500 mb-4">
              OUT NOW
            </div>
            <p className="text-2xl text-gray-300 uppercase tracking-wider">
              REARVIEW is streaming everywhere
            </p>
          </div>
        </div>
      </div>
    </section>
  );
}
